const HELPER_TEXTS = {
  PAGE_DESCRIPTION_TITLE: 'Página de ordenes activas',
  PAGE_DESCRIPTION:
    'Desde aquí puedes ver todas las ordenes activas del almacen actual, así como estadísticas rápidas sobre ellas. Tambien puedes procesar las ordenes de manera sencilla dando click sobre cualquier orden en la tabla que se muestra a continuación'
};

export default HELPER_TEXTS;
